import { createFileRoute, Outlet } from "@tanstack/react-router";

import { DocsSidebar } from "@/landing/docs/DocsSidebar";
import { MobileSidebarDrawer } from "@/landing/docs/MobileSidebarDrawer";

export const Route = createFileRoute("/_steward/docs")({
  component: DocsLayout,
});

function DocsLayout() {
  return (
    // Anchored headings clear the sticky nav, and below lg the docs bar too.
    <div className="relative border-t border-(--g-rule-soft) [--g-anchor-offset:calc(var(--header-height)+76px)] lg:flex lg:[--g-anchor-offset:calc(var(--header-height)+28px)]">
      <aside className="hidden w-[288px] flex-none border-r border-(--g-rule-soft) lg:block">
        <div className="sticky top-(--header-height) h-[calc(100dvh-var(--header-height))] overflow-y-auto pt-[calc(clamp(36px,4.5vw,64px)-10px)] pr-6 pb-12 pl-(--g-margin)">
          <DocsSidebar />
        </div>
      </aside>

      <MobileSidebarDrawer />

      <div className="min-w-0 flex-1 px-(--g-margin) pt-[clamp(36px,4.5vw,64px)] pb-(--g-section-y) lg:pl-[clamp(40px,4.4vw,72px)]">
        <Outlet />
      </div>
    </div>
  );
}
